import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { getDirectUrl } from '../../utils/mediaUtils';
import { LessonMediaButtons } from './LessonMediaButtons';

export const LessonCard = ({ lesson }) => (
  <article
    className="group bg-white border border-slate-200 rounded overflow-hidden shadow-sm hover:shadow-xl hover:-translate-y-1 transition-[transform,box-shadow] duration-300 flex flex-col"
    data-testid={`lesson-card-${lesson.order}`}
  >
    <Link to={`/gen-z/${lesson.slug}`} className="block relative aspect-[4/3] bg-brand-primary overflow-hidden" data-testid={`lesson-thumbnail-link-${lesson.order}`}>
      <img
        src={getDirectUrl(lesson.thumbnail_url)}
        alt={`Gen Z Lesson ${lesson.order}: ${lesson.title}`}
        loading="lazy"
        decoding="async"
        className="w-full h-full object-contain group-hover:scale-[1.03] transition-transform duration-500"
        data-testid={`lesson-thumbnail-${lesson.order}`}
      />
      <span className="absolute top-3 left-3 px-2.5 py-1 bg-brand-accent text-white text-xs font-semibold tracking-widest rounded">
        LESSON {lesson.order}
      </span>
    </Link>
    <div className="p-6 flex flex-col flex-grow">
      <h3 className="font-heading text-2xl font-semibold text-brand-primary leading-tight mb-3" data-testid={`lesson-title-${lesson.order}`}>
        {lesson.title}
      </h3>
      <p className="font-body text-sm leading-relaxed text-slate-600 mb-5 flex-grow line-clamp-4">
        {lesson.short_description}
      </p>
      <LessonMediaButtons lesson={lesson} />
      <Link
        to={`/gen-z/${lesson.slug}`}
        className="mt-4 inline-flex items-center gap-1.5 text-sm font-body font-medium text-brand-primary hover:text-brand-accent transition-colors duration-300"
        data-testid={`lesson-details-link-${lesson.order}`}
      >
        Full lesson details <ArrowRight className="h-4 w-4" />
      </Link>
    </div>
  </article>
);
